// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3OZjU","checkboxCol":"Table_checkboxCol__2CTdG","emailCol":"Table_emailCol__2PGG-","actionCol":"Table_actionCol__n_pAa"};